import { createAsyncThunk } from "@reduxjs/toolkit";

import { commentsService } from "../../../admin/services/comments-service";
import { showErrorStatus, showStatus } from "../../../security/state/user-slice";
import { ClientBusinessRules } from "../../../shared/model/client";
import { RootState } from "../../../shared/state/root-reducer";
import { specialistClientService } from "../../services/implementation-client-service";

export const getClients = createAsyncThunk(
  "implementationSpecialistClientContext/getClients",
  async (data: { includeFacility: boolean }, thunkAPI) => {
    const { includeFacility } = data
    const clients = await specialistClientService.getClients(includeFacility);
    // returned 'entity' contains objects for all clients, as well as clients filtered by closed, isActive, Stripe Set Up Incomplete, and more
    if (clients.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(clients.errorMessage));
      throw new Error();
    } else {
      return clients.entity;
    }
  }
);

export const getClientVobs = createAsyncThunk(
    "implementationSpecialistClientContext/getClientVobs",
    async () => {
        const clientVobs =  await specialistClientService.getClientVobs();
        if (clientVobs.hasErrors) {
            throw new Error();
        } else {
            return clientVobs.entity;
        }
    }
);

export const getClient = createAsyncThunk(
  "implementationSpecialistClientContext/getClient",
  async (clientId: number, thunkAPI) => {
    const client = await specialistClientService.getClient(clientId);
    if (client.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(client.errorMessage));
      throw new Error();
    } else {
      return client.entity;
    }
  }
);





export const saveClientBusinessRules = createAsyncThunk(
  "implementationSpecialistClientContext/saveClientBusinessRules",
  async(formValues: ClientBusinessRules, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const originalClient = {...state.implementationContext.implementationSpecialistClient.client};
    formValues.clientId = originalClient?.clientId;

    if ( (formValues.clientId === 0) || (formValues.clientId < 0) || (formValues.clientId === null) || (formValues.clientId === undefined) ) {
      thunkAPI.dispatch(showErrorStatus("Internal error - client Id is not positive."));
      throw new Error();
    }

    const response = await specialistClientService.saveClientBusinessRules(formValues);
    if (response.hasErrors) {
      throw new Error(response.errorMessage);
    } else {
      thunkAPI.dispatch(showStatus("Business Rules Updated"));
    }

    return response.entity;
  }
)



export const deleteClientComment = createAsyncThunk(
  'implementationSpecialistClientContext/deleteClientComment',
  async (data: {clientId: number, commentId: number}, thunkAPI) =>  {

      const response = await commentsService.deleteClientComment(data.clientId, data.commentId);
      if (response.hasErrors) {
        thunkAPI.dispatch(showErrorStatus(response.errorMessage))
        throw new Error(response.errorMessage);
      }

      return response.entity
  }
);












